"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cascina": {
    "a07503ea": [{
      "hkey": "c10bb600",
      "slug": "musigliano-pettori-san-sisto-al-pino",
      "name": "Musigliano-Pettori-San Sisto al Pino",
      "primary": true,
      "skipSearch": false
    }],
    "badia-musigliano-pettori": [{
      "hkey": "c10bb600",
      "slug": "musigliano-pettori-san-sisto-al-pino",
      "name": "Musigliano-Pettori-San Sisto al Pino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7d3a8554": [{
      "hkey": "6a3a87b0",
      "slug": "casciavola-navacchio-san-prospero",
      "name": "Casciavola-Navacchio-San Prospero",
      "primary": true,
      "skipSearch": false
    }],
    "casciavola-novacchio-san-prospero": [{
      "hkey": "6a3a87b0",
      "slug": "casciavola-navacchio-san-prospero",
      "name": "Casciavola-Navacchio-San Prospero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3f9d0b92": [{
      "hkey": "c9b92b92",
      "slug": "san-casciano-san-frediano-a-settimo-san-lorenzo-a-pagnatico",
      "name": "San Casciano-San Frediano a Settimo-San Lorenzo a Pagnatico",
      "primary": true,
      "skipSearch": false
    }],
    "san-casciano": [{
      "hkey": "c9b92b92",
      "slug": "san-casciano-san-frediano-a-settimo-san-lorenzo-a-pagnatico",
      "name": "San Casciano-San Frediano a Settimo-San Lorenzo a Pagnatico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cascina"
    }],
    "706ca26d": [{
      "hkey": "c9b92b92",
      "slug": "san-casciano-san-frediano-a-settimo-san-lorenzo-a-pagnatico",
      "name": "San Casciano-San Frediano a Settimo-San Lorenzo a Pagnatico",
      "primary": true,
      "skipSearch": false
    }],
    "san-frediano-san-lorenzo-a-pagnatico": [{
      "hkey": "c9b92b92",
      "slug": "san-casciano-san-frediano-a-settimo-san-lorenzo-a-pagnatico",
      "name": "San Casciano-San Frediano a Settimo-San Lorenzo a Pagnatico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e88e4298": [{
      "hkey": "ec06caf2",
      "slug": "badia-montione-san-lorenzo-alle-corti",
      "name": "Badia-Montione-San Lorenzo alle Corti",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo-alle-corti": [{
      "hkey": "ec06caf2",
      "slug": "badia-montione-san-lorenzo-alle-corti",
      "name": "Badia-Montione-San Lorenzo alle Corti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3fceea69": [{
      "hkey": "c10bb600",
      "slug": "musigliano-pettori-san-sisto-al-pino",
      "name": "Musigliano-Pettori-San Sisto al Pino",
      "primary": true,
      "skipSearch": false
    }],
    "4c4cd2f0": [{
      "hkey": "c10bb600",
      "slug": "musigliano-pettori-san-sisto-al-pino",
      "name": "Musigliano-Pettori-San Sisto al Pino",
      "primary": true,
      "skipSearch": false
    }],
    "5ece0b8d": [{
      "hkey": "c10bb600",
      "slug": "musigliano-pettori-san-sisto-al-pino",
      "name": "Musigliano-Pettori-San Sisto al Pino",
      "primary": true,
      "skipSearch": false
    }],
    "baida-musigliano": [{
      "hkey": "c10bb600",
      "slug": "musigliano-pettori-san-sisto-al-pino",
      "name": "Musigliano-Pettori-San Sisto al Pino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c632d49a": [{
      "hkey": "31d756d9",
      "slug": "santo-stefano-a-macerata-chiesanuova",
      "name": "Santo Stefano a Macerata-Chiesanuova",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano-a-macerata": [{
      "hkey": "31d756d9",
      "slug": "santo-stefano-a-macerata-chiesanuova",
      "name": "Santo Stefano a Macerata-Chiesanuova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ac5bc413": [{
      "hkey": "c10bb600",
      "slug": "musigliano-pettori-san-sisto-al-pino",
      "name": "Musigliano-Pettori-San Sisto al Pino",
      "primary": true,
      "skipSearch": false
    }],
    "badia": [{
      "hkey": "c10bb600",
      "slug": "musigliano-pettori-san-sisto-al-pino",
      "name": "Musigliano-Pettori-San Sisto al Pino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "musigliano": [{
      "hkey": "c10bb600",
      "slug": "musigliano-pettori-san-sisto-al-pino",
      "name": "Musigliano-Pettori-San Sisto al Pino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-sisto": [{
      "hkey": "c10bb600",
      "slug": "musigliano-pettori-san-sisto-al-pino",
      "name": "Musigliano-Pettori-San Sisto al Pino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;